import React from "react"
import Home from "../base-pages/index"

const HomeCN = () => {
  return <Home lang="cn" />
}

export default HomeCN
